import groupBy from 'lodash/groupBy';

import { useEnergyOptions } from '~src/context/EnergyOptionsContext';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import { DeepPartial, HeatPumpOutdoorUnit, Residence } from '~src/model';
import { isResidenceFilled, calculateHeatPumpScores, calculateResidenceHeatingRequired } from '~src/util';

export const useCheapestOutdoorUnitPerBrand = (
  inputResidence?: DeepPartial<Residence>,
  inputOutdoorUnits?: HeatPumpOutdoorUnit[]
) => {
  const { residence: contextResidence, outdoorUnits: contextOutdoorUnits } = usePublicCalculatorContext();
  const energyOptions = useEnergyOptions();

  const residence = inputResidence ?? contextResidence;
  const outdoorUnits = inputOutdoorUnits ?? contextOutdoorUnits;

  if (!residence || !isResidenceFilled(residence)) {
    return [];
  }

  const heatingRequired = calculateResidenceHeatingRequired(residence, energyOptions);

  if (!heatingRequired) {
    return [];
  }

  const { available: bestHeatPumps } = calculateHeatPumpScores(
    outdoorUnits ?? [],
    { ...residence, noiseWeight: 'small' } as Residence,
    heatingRequired
  );

  const sortedByPrice = bestHeatPumps.sort((a, b) => a.price - b.price);

  return Object.values(groupBy(sortedByPrice, 'brand')).map(item => item[0]);
};
